<template lang="html">
  <info-icon
    :icon="icon"
    :color="color"
    :message="message"/>
</template>

<script>
import InfoIcon from './InfoIcon'
export default {
  components: {
    'info-icon': InfoIcon
  },
  data: () => ({
    icon: 'mdi-flag-checkered',
    color: 'success',
    message: 'Trip Planner is ready to book'
  })
}
</script>

<style lang="css" scoped>
</style>
